import { DefaultModal } from '@frontend/components/mobile';
import { DefaultModalProps, ModalType } from '@frontend/elements';
import { CommonMessage } from '@frontend/lang';
import { PinCodeView } from '@frontend/pin-code/components';
import { PinCode } from '@frontend/pin-code/types';

import usePinCodeModal from './pin-code-modal.controller';

export interface PinCodeModalProps extends DefaultModalProps {
    pinCode?: PinCode;
}

const PinCodeModal = (props: PinCodeModalProps) => {
    const viewProps = usePinCodeModal(props);
    return (
        <DefaultModal
            handleClose={props.handleClose}
            show={props.show}
            className='m-5 w-full'
            type={ModalType.PROMPT}>
            <div
                onClick={(e) => e.stopPropagation()}
                className='bg-background-surface flex w-full flex-col items-center justify-center gap-4 overflow-hidden rounded-3xl px-16 py-8'
                id='pin-code-modal'>
                <div className='flex flex-col items-center justify-start gap-2'>
                    <p className='text-xl font-semibold'>{viewProps.title}</p>
                </div>

                <PinCodeView
                    className='text-always-black flex w-full flex-col items-center justify-center gap-4'
                    pinCode={props.pinCode}
                />

                <div
                    onClick={(e) => {
                        e.stopPropagation();
                        props.handleClose();
                    }}
                    className='outline-brand-primary inline-flex items-center justify-start gap-2 rounded-xl px-5 py-3.5 outline-2 outline-offset-[-2px]'>
                    <div className='text-brand-primary justify-start text-base font-medium'>{CommonMessage.BUTTONS.CLOSE}</div>
                </div>
            </div>
        </DefaultModal>
    );
};

export default PinCodeModal;
